'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var styled = require('styled-components');
var PropTypes = require('prop-types');
var index = require('../core/index.js');
var themeGet = require('../utils/themeGet.js');
var motion = require('../theme/motion.js');
var useClickAway = require('../hooks/useClickAway.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  height: 44px;\n  padding: 10px 12px;\n  align-items: center;\n  font-weight: normal;\n  cursor: pointer;\n  transition: all 0.3s ease-in-out;\n  text-overflow: ellipsis;\n  user-select: none;\n  line-height: unset;\n  &:hover {\n    color: ", ";\n    background-color: ", ";\n  }\n  ", "\n  ", "\n\n      ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  display: block;\n  min-width: 152px;\n  border-radius: 12px;\n  max-height: 176px;\n  ", "\n  overflow: scroll;\n  z-index: 2;\n  opacity: 0;\n  visibility: hidden;\n  pointer-events: none;\n  background-color: white;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n  transition: all 0.2s ", ";\n  ", "\n  ", "\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  ", "\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var StyledMenu = styled__default['default'].div(_templateObject(), function (props) {
  return props.disabled ? "\n    cursor: not-allowed;\n    opacity: 0.5;\n  " : "cursor: pointer;";
});
var ItemWrapper = styled__default['default'].div(_templateObject2(), function (props) {
  return "\n      ".concat(props.anchor === 'center' ? "left: -220%;" : '', "\n      ").concat(props.anchor === 'left' ? "left: 0;" : '', "\n      ").concat(props.anchor === 'right' ? "right: 0;" : '', "\n    ");
}, motion.easeInOutCircle, function (_ref) {
  var open = _ref.open;
  return open && styled.css(["opacity:1;visibility:visible;pointer-events:all;transform:translateY(12px);"]);
}, index.styleEngine);
var StyledItem = styled__default['default'].div(_templateObject3(), themeGet['default']('colors.primary'), themeGet['default']('colors.nonConformist.activeBg'), index.styleEngine, function (props) {
  return props.disabled ? "\n    cursor: not-allowed;\n  " : "";
}, function (_ref2) {
  var sub = _ref2.sub;
  return sub && "\n      justify-content: center;\n      align-items: flex-start;\n      flex-direction: column;";
});
var Sub = styled__default['default'].p(_templateObject4(), index.styleEngine);

var Item = function Item(_ref3) {
  var children = _ref3.children,
      otherProps = _objectWithoutProperties(_ref3, ["children"]);

  return /*#__PURE__*/React__default['default'].createElement(StyledItem, otherProps, children);
};

var Menu = function Menu(_ref4) {
  var disabled = _ref4.disabled,
      render = _ref4.render,
      children = _ref4.children,
      anchor = _ref4.anchor,
      _onClick2 = _ref4.onClick,
      wrapperProps = _ref4.wrapperProps,
      _ref4$items = _ref4.items,
      items = _ref4$items === void 0 ? [] : _ref4$items,
      restProps = _objectWithoutProperties(_ref4, ["disabled", "render", "children", "anchor", "onClick", "wrapperProps", "items"]);

  var _useState = React.useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      visible = _useState2[0],
      setVisible = _useState2[1];

  var ref = useClickAway['default'](function () {
    return setVisible(false);
  });
  return /*#__PURE__*/React__default['default'].createElement(StyledMenu, _extends({}, restProps, {
    ref: ref,
    disabled: disabled,
    onClick: function onClick() {
      if (!disabled) {
        setVisible(!visible);
        _onClick2 && _onClick2();
      }
    }
  }), children, /*#__PURE__*/React__default['default'].createElement(ItemWrapper, _extends({
    anchor: anchor,
    open: visible
  }, wrapperProps), items.map(function (_ref5, inx) {
    var disabled = _ref5.disabled,
        _onClick = _ref5.onClick,
        name = _ref5.name,
        sub = _ref5.sub,
        restProps = _objectWithoutProperties(_ref5, ["disabled", "onClick", "name", "sub"]);

    return /*#__PURE__*/React__default['default'].createElement(Item, _extends({}, restProps, {
      sub: sub,
      key: inx,
      onClick: function onClick(event) {
        event.stopPropagation();

        if (!disabled) {
          setVisible(false);
          _onClick && _onClick();
        }
      }
    }), name, sub && /*#__PURE__*/React__default['default'].createElement(Sub, sub, sub === null || sub === void 0 ? void 0 : sub.name));
  })));
};

Menu.Item = Item;
Menu.propTypes = {
  onChange: PropTypes__default['default'].func,
  disabled: PropTypes__default['default'].bool,
  render: PropTypes__default['default'].func,
  children: PropTypes__default['default'].node,
  onClick: PropTypes__default['default'].func,
  wrapperProps: PropTypes__default['default'].object,
  anchor: PropTypes__default['default'].oneOf(['left', 'right', 'center'])
};
Menu.defaultProps = {
  size: 'small',
  anchor: 'center'
};
Item.propTypes = {
  children: PropTypes__default['default'].node
};

exports.default = Menu;
